import angular from "angular";
import Vue from "vue";
import "ngVue";

// import VueCardFormat from 'vue-credit-card-validation';
// Vue.use(VueCardFormat);

import dcOrderDetail from "./OrderDetail.vue";

export default angular
  .module("directives.orderdetail", [])
  .directive("dcOrderDetail", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcOrderDetail", dcOrderDetail));
    },
  ]);
